import React, { useState, useEffect, useMemo, useRef } from "react";
import { Link, useParams, useNavigate } from "react-router-dom";
import { all_routes } from "../../Router/all_routes";
import Select from "react-select";
// import { DatePicker } from "antd";
import Addunits from "../../core/modals/inventory/addunits";
import AddCategory from "../../core/modals/inventory/addcategory";
import AddBrand from "../../core/modals/addbrand";
import { ArrowLeft, ChevronUp, Info, LifeBuoy, PlusCircle, Trash2, X } from "feather-icons-react/build/IconComponents";
import { useDispatch, useSelector } from "react-redux";
import { setToogleHeader } from "../../core/redux/action";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import * as Yup from "yup";
import { apiClient } from "../../services/apiClient";
import { yupResolver } from "@hookform/resolvers/yup";
import { useForm, Controller, useFieldArray } from "react-hook-form";
import { useToast } from "../../Toaster/ToastContext";
import dayjs from "dayjs";
import AddVariant from '../../core/modals/inventory/addvariant';

const generateRandomSKU = () => {
  const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';
  let result = '';
  for (let i = 0; i < 8; i++) {
    result += characters.charAt(Math.floor(Math.random() * characters.length));
  }
  return result;
};

const validationSchema = Yup.object({
  branch_id: Yup.number().required("Branch is required"),
  name: Yup.string().required("Product name is required"),
  sku: Yup.string().required("SKU is required"),
  category_id: Yup.string().required("Brand is required"),
  // brand_id: Yup.number().positive("Brand is required"),
  unit: Yup.string().required("Unit is required"),
  // selling_type: Yup.string().required("Selling Type is required"),
  product_type: Yup.string(),
  quantity: Yup.string().when("product_type", {
    is: "single",
    then: (schema) => schema.required("Quantity is required"),
    otherwise: (schema) => schema.notRequired(),
  }),
  price: Yup.string().when("product_type", {
    is: "single",
    then: (schema) =>
      schema.required("Price is required"),
    otherwise: (schema) => schema.notRequired(),
  }),
  variantAttribute: Yup.string().when("product_type", {
    is: "variable",
    then: (schema) => schema.required("Variant attribute is required"),
    otherwise: (schema) => schema.notRequired(),
  }),
  variants: Yup.array().when("product_type", {
    is: "variable",
    then: (schema) =>
      schema.of(
        Yup.object({
          name: Yup.string().required("Variation name is required"),
          variant_value: Yup.string().required("Variant value is required"),
          sku: Yup.string().required("SKU is required"),
          quantity: Yup.number()
            .required("Quantity is required")
            .positive("Quantity must be positive")
            .typeError("Quantity must be a number"),
          price: Yup.number()
            .required("Price is required")
            .positive("Price must be positive")
            .typeError("Price must be a number"),
          discount_type: Yup.string(null).notRequired(),
          discount_value: Yup.number(0).notRequired(),
          low_stock: Yup.number(null).required("Low Stock value is required")
        })
      ).min(1, "At least one variant is required"),
    otherwise: (schema) => schema.notRequired(),
  }),
  is_warranty: Yup.boolean(),
  warranty: Yup.string().when("is_warranty", {
    is: true,
    then: (schema) => schema.required("Warranty is required"),
    otherwise: (schema) => schema.notRequired(),
  }),
  is_manufacturer: Yup.boolean(),
  manufacturer: Yup.string().when("is_manufacturer", {
    is: true,
    then: (schema) => schema.required("Manufacturer is required"),
    otherwise: (schema) => schema.notRequired(),
  }),
  manufacturer_date: Yup.mixed().when("is_manufacturer", {
    is: true,
    then: (schema) =>
      schema
        .required("Manufactured date is required")
        .test("is-valid-date", "Manufactured date must be a valid date", (value) =>
          value ? dayjs.isDayjs(value) ? value.isValid() : value instanceof Date && !isNaN(value) : false
        )
        .transform((value) => (dayjs.isDayjs(value) ? value.toDate() : value)),
    otherwise: (schema) => schema.nullable().notRequired(),
  }),
  is_expiry: Yup.boolean(),
  expiry_on: Yup.mixed().when("is_expiry", {
    is: true,
    then: (schema) =>
      schema
        .required("Expiry date is required")
        .test("is-valid-date", "Expiry date must be a valid date", (value) =>
          value ? dayjs.isDayjs(value) ? value.isValid() : value instanceof Date && !isNaN(value) : false
        )
        .transform((value) => (dayjs.isDayjs(value) ? value.toDate() : value)),
    otherwise: (schema) => schema.nullable().notRequired(),
  }),
  images: Yup.mixed()
    .required("At least one image is required")
    .test("file-count", "At least one image is required", (value) => {
      return value && value.length > 0;
    }),
});

const defaultValues = {
  branch_id: "",
  name: "",
  slug: "",
  product_type: "single",
  sku: "",
  quantity: "",
  price: "",
  category_id: "",
  // brand_id: "",
  unit: "",
  // selling_type: "",
  barcodeSymbology: "",
  itemCode: "",
  description: "",
  discount_type: null,
  discount_value: 0,
  images: null,
  is_expiry: false,
  is_manufacturer: false,
  is_warranty: true,
  warranty: "",
  manufacturer: "",
  manufacturer_date: null,
  expiry_on: null,
  variantAttribute: "",
  variants: [],
  low_stock: 0,
};

const AddProduct = () => {

  const {
    control,
    handleSubmit,
    watch,
    register,
    formState: { errors, isSubmitting },
    reset,
    setValue
  } = useForm({
    defaultValues,
    resolver: yupResolver(validationSchema),
  });
  const { id } = useParams();
  const navigate = useNavigate();
  const isEditMode = !!id;
  const route = all_routes;
  const { showToast } = useToast();
  const dispatch = useDispatch();
  const data = useSelector((state) => state.toggle_header);
  const [imagePreviews, setImagePreviews] = useState([]);
  const [newImages, setNewImages] = useState([]);
  const [storeOptions, setStoreOptions] = useState([]);
  const [categoryOptions, setCategoryOptions] = useState([{ value: "choose", label: "Choose" }]);
  // const [brandOptions, setBrandOptions] = useState([{ value: "choose", label: "Choose" }]);
  const [variantOptions, setVariantOptions] = useState([{ value: "choose", label: "Choose" }]);
  const product_type = watch("product_type");
  const variantAttribute = watch("variantAttribute");
  const isWarranty = watch("is_warranty");
  // const isManufacturer = watch("is_manufacturer");
  // const isExpiry = watch("is_expiry");
  const [product, setProduct] = useState();
  const [permissions, setPermissions] = useState({
    create: false,
    read: false,
    update: false,
    delete: false,
  });
  const [currentVariant, setCurrentVariant] = useState(null);
  const hasFetched = useRef(false);
  const showToastRef = useRef(showToast);

  const { fields, remove, replace } = useFieldArray({
    control,
    name: "variants",
  });

  useEffect(() => {
    if (!isEditMode) {
      setValue("slug", generateRandomSKU());
      setValue("sku", generateRandomSKU());
    }
  }, [isEditMode, setValue]);

  useEffect(() => {
    const storedPermissions = localStorage.getItem("rolespermissions");
    let parsedPermissions = [];
    try {
      const Permissions = JSON.parse(storedPermissions);
      const getPermissions = JSON.parse(Permissions.permissions)
      if (getPermissions.permissions) {
        parsedPermissions = getPermissions.permissions;
      }
      else {
        parsedPermissions = getPermissions;
      }

      const inventoryPermissions = parsedPermissions.find(
        (item) => item.title === "Inventory"
      );

      const productPermissions = inventoryPermissions?.childPage?.find(
        (child) => child.title === "Products"
      );
      // console.log("search product", productPermissions)

      if (productPermissions) {
        setPermissions({
          create: productPermissions.create || false,
          read: productPermissions.read || false,
          update: productPermissions.update || false,
          delete: productPermissions.delete || false,
        });
      } else {
        // console.error("Product permissions not found in localStorage");
        showToast("Product permissions not found.", "error", "Permissions Error");
      }
    } catch (error) {
      // console.error("Error parsing permissions from localStorage:", error);
      showToast("Failed to load permissions.", "error", "Permissions Error");
    }
  }, []);

  useEffect(() => {
    showToastRef.current = showToast;
  }, [showToast]);

  useEffect(() => {
    const fetchDataSequentially = async () => {
      try {
        if (!id) {
          reset({
            ...defaultValues,
            slug: generateRandomSKU(),
            sku: generateRandomSKU()
          });
          imagePreviews.forEach((preview) => URL.revokeObjectURL(preview));
          setImagePreviews([]);
          setNewImages([]);
        }

        // Fetch branches
        if (storeOptions.length <= 1) {
          const branchResponse = await apiClient.get("/get-all-branch");
          if (branchResponse.success) {
            const branches = branchResponse.data?.map((branch) => ({
              value: branch.id.toString(),
              label: branch.name,
            }));
            setStoreOptions(branches);
            if (branches.length > 0 && !isEditMode) {
              setValue("branch_id", branches[0].value);
            }
          } else {
            throw new Error("Failed to fetch branches.");
          }
        }

        // Fetch categories
        if (categoryOptions.length <= 1) {
          const categoryResponse = await apiClient.get("/get-all-category");
          if (categoryResponse.success) {
            const categories = categoryResponse.data?.map((category) => ({
              value: category.id.toString(),
              label: category.name,
            }));
            setCategoryOptions([{ value: "choose", label: "Choose" }, ...categories]);
          } else {
            throw new Error("Failed to fetch categories.");
          }
        }

        // Fetch brands
        // if (brandOptions.length <= 1) {
        //   const brandResponse = await apiClient.get("/get-all-brand");
        //   if (brandResponse.success) {
        //     const brands = brandResponse.data?.map((brand) => ({
        //       value: brand.id.toString(),
        //       label: brand.name,
        //     }));
        //     setBrandOptions([{ value: "choose", label: "Choose" }, ...brands]);
        //   } else {
        //     throw new Error("Failed to fetch brands.");
        //   }
        // }

        // Fetch product data for edit mode
        if (id) {
          const productResponse = await apiClient.get(`/edit-product/${id}`);
          if (productResponse.success) {
            const { product } = productResponse;
            setProduct(product);
            let images = [];
            if (product?.image) {
              try {
                images = Array.isArray(product.image) ? product.image : JSON.parse(product.image);
              } catch (error) {
                console.warn(`Invalid image format for product ID ${id}: ${error.message}`);
              }
            }
            setImagePreviews(images);

            let variantAttributeId = "";
            if (product.variants?.length > 0 && product.variants[0].varient_id) {
              variantAttributeId = product.variants[0].varient_id.toString();
            }

            reset(
              {
                id: product.id,
                branch_id: product.branch_id?.toString() || "",
                name: product.name || "",
                slug: product.slug || "",
                product_type: product.product_type || "",
                sku: product.sku || "",
                quantity: product.quantity || "",
                price: product.price || "",
                variants: product.variants?.map((variant) => ({
                  id: variant.id,
                  product_id: variant.product_id,
                  name: variant.name,
                  variant_value: variant.variant_value,
                  sku: variant.sku,
                  quantity: variant.quantity,
                  price: parseFloat(variant.price) || 0,
                  discount_type: variant.discount_type || null,
                  discount_value: variant.discount_value || 0,
                  low_stock: variant.low_stock || 0,
                })) || [],
                category_id: product.category_id?.toString() || "",
                // brand_id: product.brand_id?.toString() || "",
                unit: product.unit || "",
                // selling_type: product.selling_type || "",
                barcodeSymbology: product.barcodeSymbology || "",
                itemCode: product.itemCode || "",
                description: product.description || "",
                discount_type: product.discount_type || null,
                discount_value: product.discount_value || 0,
                low_stock: product.low_stock || 0,
                is_expiry: !!product.is_expiry,
                is_manufacturer: !!product.is_manufacturer,
                is_warranty: !!product.is_warranty,
                warranty: product.warranty || "",
                manufacturer: product.manufacturer || "",
                manufacturer_date: product.manufacturer_date ? new Date(product.manufacturer_date) : null,
                expiry_on: product.expiry_on ? new Date(product.expiry_on) : null,
                variantAttribute: variantAttributeId,
                images: images.length > 0 ? images : null,
              },
              { keepDirty: false, keepTouched: false }
            );
          } else {
            throw new Error(productResponse.message || "Invalid product data.");
          }
        }
      } catch (error) {
        // console.error("Error fetching data:", error.message);
        showToastRef.current(error.message || "Failed to load data.", "error", "Data Error");
      }
    };

    // Only run when id changes or on initial mount
    if (!hasFetched.current) {
      hasFetched.current = true;
      fetchDataSequentially();
    }
  }, [id, reset]);

  useEffect(() => {
    if (product_type === "variable") {
      const fetchVariants = async () => {
        try {
          const response = await apiClient.get("/get-all-varient");
          if (response.success) {
            const variants = response.data?.map((variant) => ({
              value: variant.id.toString(),
              label: variant.name,
              values: JSON.parse(variant.value),
            }));
            setVariantOptions([{ value: "choose", label: "Choose" }, ...variants]);
          }
        } catch (error) {
          // console.error("Error fetching variants:", error);
          showToast("Failed to fetch variants.", "error", "Variant Error");
        }
      };
      fetchVariants();
    }
  }, [product_type, showToast]);

  useEffect(() => {
    if (product_type !== "variable" || !variantAttribute || variantAttribute === "choose") {
      return;
    }

    const selectedVariant = variantOptions.find((option) => option.value === variantAttribute);

    if (selectedVariant && selectedVariant.values && !product?.variants?.length) {
      const variantRows = selectedVariant.values.map((value) => ({
        product_id: id || "",
        name: selectedVariant.label,
        variant_value: value,
        sku: generateRandomSKU(),
        quantity: 0,
        price: 0,
        discount_type: null,
        discount_value: 0,
        low_stock: 0,
      }));
      replace(variantRows);
    }
  }, [variantAttribute, product_type, id, replace]);


  const unitOptions = useMemo(
    () => [
      { value: "", label: "Choose" },
      { value: "kg", label: "Kg" },
      { value: "pc", label: "Pc" },
    ],
    []
  );

  // const sellingTypeOptions = useMemo(
  //   () => [
  //     { value: "", label: "Choose" },
  //     { value: "transactional", label: "Transactional Selling" },
  //     { value: "solution", label: "Solution Selling" },
  //   ],
  //   []
  // );

  const warrantyOptions = [
    { label: "Replacement Warranty", value: "replacement" },
    { label: "On-Site Warranty", value: "on_site" },
    { label: "Accidental Protection Plan", value: "accidental" },
  ];

  const discountTypeOptions = useMemo(
    () => [
      { value: "", label: "Choose" },
      { value: "percentage", label: "Percentage" },
      { value: "cash", label: "Fixed" },
    ],
    []
  );

  const onSubmit = async (data) => {
    try {
      const formData = new FormData();
      const imagesArray = [
        ...(imagePreviews.length > 0 ? [imagePreviews[0]] : []),
        ...(newImages.length > 0 ? [newImages[0]] : []),
      ].filter((item) => item !== null);

      imagesArray.forEach((image, index) => {
        if (image instanceof File) {
          formData.append(`images[${index}]`, image);
        } else {
          formData.append(`images[${index}]`, image);
        }
      });

      Object.entries(data).forEach(([key, value]) => {
        if (key !== "images") {
          if (key === "variants") {
            const variantsWithProductId = value.map((variant) => ({
              ...variant,
              product_id: data.id || "",
              varient_id: data.variantAttribute || "",
              discount_value: parseFloat(variant.discount_value) || 0,
              low_stock: variant.low_stock || 0,
            }));
            formData.append("variants", JSON.stringify(variantsWithProductId));
          } else if (key === "manufacturer_date" || key === "expiry_on") {
            formData.append(key, value ? value.toISOString() : "");
          } else if (key === "discount_value") {
            formData.append(key, parseFloat(value) || 0);
          }
          else if(key === 'low_stock') {
            formData.append(key, value)
          }
          else {
            formData.append(key, value);
          }
        }
      });

      const response = await apiClient.post("/store-update-product", formData, true);
      // console.log(response);

      if (!response.success) throw new Error(response.message || "Failed to save product.");

      showToastRef.current(
      response.message || `Product ${isEditMode ? "updated" : "added"} successfully!`,
      "success",
      "Product"
    );
      reset({
        ...defaultValues,
        slug: generateRandomSKU(),
        sku: generateRandomSKU()
      });
      setImagePreviews([]);
      navigate(route.productlist);
    } catch (error) {
      console.error(`Error ${isEditMode ? "updating" : "adding"} product:`, error.message);
      showToastRef.current(
        error.message || `Error ${isEditMode ? "updating" : "adding"} product. Please try again.`,
        "error",
        "Product Error"
      );
    }
  };

  const handleImageChange = (e) => {
    const files = e.target.files;
    if (files) {
      const newFiles = Array.from(files);
      setNewImages((prev) => [...prev, ...newFiles]); 
      const newPreviews = newFiles.map((file) => URL.createObjectURL(file));
      setImagePreviews((prev) => [...prev, ...newPreviews]);
    }
  };

  const renderCollapseTooltip = (props) => (
    <Tooltip id="collapse-tooltip" {...props}>
      Collapse
    </Tooltip>
  );

  const handleAddVariants = () => {
    setCurrentVariant(null);
  };

  return (
    <div className="page-wrapper">
      <div className="content">
        <div className="page-header">
          <div className="add-item d-flex">
            <div className="page-title">
              <h4>{isEditMode ? "Edit Product" : "New Product"}</h4>
              <h6>{isEditMode ? "Update existing product" : "Create new product"}</h6>
            </div>
          </div>
          <ul className="table-top-head">
            <li>
              <div className="page-btn">
                <Link to={route.productlist} className="btn btn-secondary">
                  <ArrowLeft className="me-2" />
                  Back to Product
                </Link>
              </div>
            </li>
            <li>
              <OverlayTrigger placement="top" overlay={renderCollapseTooltip}>
                <Link
                  data-bs-toggle="tooltip"
                  data-bs-placement="top"
                  title="Collapse"
                  id="collapse-header"
                  className={data ? "active" : ""}
                  onClick={() => dispatch(setToogleHeader(!data))}
                >
                  <ChevronUp className="feather-chevron-up" />
                </Link>
              </OverlayTrigger>
            </li>
          </ul>
        </div>
        <form onSubmit={handleSubmit(onSubmit)}>
          <div className="card">
            <div className="card-body add-product pb-0">
              <div className="accordion-card-one accordion" id="accordionExample">
                <div className="accordion-item">
                  <div className="accordion-header" id="headingOne">
                    <div
                      className="accordion-button"
                      data-bs-toggle="collapse"
                      data-bs-target="#collapseOne"
                      aria-controls="collapseOne"
                    >
                      <div className="addproduct-icon">
                        <h5>
                          <Info className="add-info" />
                          <span>Product Information</span>
                        </h5>
                      </div>
                    </div>
                  </div>
                  <div
                    id="collapseOne"
                    className="accordion-collapse collapse show"
                    aria-labelledby="headingOne"
                    data-bs-parent="#accordionExample"
                  >
                    <div className="accordion-body">
                      <div className="row">
                        <div className="col-lg-6 col-sm-6 col-12">
                          <div className="mb-3 add-product">
                            <label className="form-label">Branch</label>
                            <Controller
                              name="branch_id"
                              control={control}
                              render={({ field }) => (
                                <Select
                                  options={storeOptions}
                                  value={storeOptions.find((o) => o.value === field.value)}
                                  onChange={(option) => field.onChange(option?.value)}
                                  placeholder="Choose"
                                  aria-label="Select branch"
                                />
                              )}
                            />
                            {errors.branch_id && (
                              <span className="text-danger">{errors.branch_id.message}</span>
                            )}
                          </div>
                        </div>
                        <div className="col-lg-6 col-sm-6 col-12">
                          <div className="mb-3 add-product">
                            <label className="form-label">Product Name</label>
                            <input
                              {...register("name")}
                              className="form-control"
                              style={{ height: '54px' }}
                              aria-label="Product name"
                            />
                            {errors.name && (
                              <span className="text-danger">{errors.name.message}</span>
                            )}
                          </div>
                        </div>
                        {/* <div className="col-lg-6 col-sm-6 col-12">
                          <div className="mb-3 add-product">
                            <label className="form-label">Slug</label>
                            <input
                              {...register("slug")}
                              className="form-control"
                              readOnly
                              aria-label="Slug"
                            />
                            {errors.slug && (
                              <span className="text-danger">{errors.slug.message}</span>
                            )}
                          </div>
                        </div> */}
                        {/* <div className="col-lg-6 col-sm-6 col-12">
                          <div className="input-blocks add-product list">
                            <label>SKU</label>
                            <input
                              {...register("sku")}
                              className="form-control"
                              readOnly
                              aria-label="SKU"
                            />
                            {errors.sku && (
                              <span className="text-danger">{errors.sku.message}</span>
                            )}
                            <Link to={route.addproduct} className="btn btn-primaryadd">
                              Generate Code
                            </Link>
                          </div>
                        </div> */}
                        <div className="addservice-info">
                          <div className="row">
                            <div className="col-lg-6 col-sm-6 col-12">
                              <div className="mb-3 add-product">
                                <div className="add-newplus">
                                  <label className="form-label">Brand</label>
                                </div>
                                <Controller
                                  name="category_id"
                                  control={control}
                                  render={({ field }) => (
                                    <Select
                                      options={categoryOptions}
                                      value={categoryOptions.find((o) => o.value === field.value)}
                                      onChange={(option) => field.onChange(option?.value)}
                                      placeholder="Choose"
                                      aria-label="Select category"
                                    />
                                  )}
                                />
                                {errors.category_id && (
                                  <span className="text-danger">{errors.category_id.message}</span>
                                )}
                              </div>
                            </div>
                            {/* <div className="col-lg-6 col-sm-6 col-12">
                              <div className="mb-3 add-product">
                                <div className="add-newplus">
                                  <label className="form-label">Brand</label>
                                </div>
                                <Controller
                                  name="brand_id"
                                  control={control}
                                  render={({ field }) => (
                                    <Select
                                      options={brandOptions}
                                      value={brandOptions.find((o) => o.value === field.value)}
                                      onChange={(option) => field.onChange(option?.value)}
                                      placeholder="Choose"
                                      aria-label="Select brand"
                                    />
                                  )}
                                />
                                {errors.brand_id && (
                                  <span className="text-danger">{errors.brand_id.message}</span>
                                )}
                              </div>
                            </div> */}
                            <div className="col-lg-6 col-sm-6 col-12">
                              <div className="mb-3 add-product">
                                <div className="add-newplus">
                                  <label className="form-label">Unit</label>
                                </div>
                                <Controller
                                  name="unit"
                                  control={control}
                                  render={({ field }) => (
                                    <Select
                                      options={unitOptions}
                                      value={unitOptions.find((o) => o.value === field.value)}
                                      onChange={(option) => field.onChange(option?.value)}
                                      placeholder="Choose"
                                      aria-label="Select unit"
                                    />
                                  )}
                                />
                                {errors.unit && (
                                  <span className="text-danger">{errors.unit.message}</span>
                                )}
                              </div>
                            </div>
                            {/* <div className="col-lg-6 col-sm-6 col-12">
                              <div className="mb-3 add-product">
                                <label className="form-label">Selling Type</label>
                                <Controller
                                  name="selling_type"
                                  control={control}
                                  render={({ field }) => (
                                    <Select
                                      options={sellingTypeOptions}
                                      value={sellingTypeOptions.find((o) => o.value === field.value)}
                                      onChange={(option) => field.onChange(option?.value)}
                                      placeholder="Choose"
                                      aria-label="Select selling type"
                                    />
                                  )}
                                />
                                {errors.selling_type && (
                                  <span className="text-danger">{errors.selling_type.message}</span>
                                )}
                              </div>
                            </div> */}
                          </div>
                        </div>
                        <div className="col-lg-12">
                          <div className="input-blocks summer-description-box transfer mb-3">
                            <label>Description</label>
                            <textarea
                              {...register("description")}
                              className="form-control"
                              rows="3"
                              aria-label="Product description"
                            />
                            {errors.description && (
                              <span className="text-danger">{errors.description.message}</span>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* Variants section */}
              <div className="accordion-card-one accordion"
                id="accordionExample2"
              >
                <div className="accordion-item">
                  <div className="accordion-header" id="headingTwo">
                    <div
                      className="accordion-button"
                      data-bs-toggle="collapse"
                      data-bs-target="#collapseTwo"
                      aria-controls="collapseTwo"
                    >
                      <div className="text-editor add-list">
                        <div className="addproduct-icon list icon">
                          <h5>
                            <LifeBuoy className="add-info" />
                            <span>Pricing &amp; Stocks</span>
                          </h5>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    id="collapseTwo"
                    className="accordion-collapse collapse show"
                    aria-labelledby="headingTwo"
                    data-bs-parent="#accordionExample2"
                  >
                    <div className="accordion-body">
                      <div className="input-blocks add-products">
                        <label className="d-block">Product Type</label>
                        <div className="single-pill-product">
                          <ul
                            className="nav nav-pills"
                            id="pills-tab1"
                            role="tablist"
                          >
                            <li className="nav-item" role="presentation">
                              <span
                                className={`custom_radio me-4 mb-0 ${product_type === "single" ? "active" : ""}`}
                                id="pills-home-tab"
                                data-bs-toggle="pill"
                                data-bs-target="#pills-home"
                                role="tab"
                                aria-controls="pills-home"
                                aria-selected={product_type === "single"}
                              >
                                <input
                                  type="radio"
                                  className="form-control"
                                  name="product_type"
                                  value="single"
                                  {...register("product_type")}
                                />
                                <span className="checkmark" /> Single Product
                              </span>
                            </li>
                            <li className="nav-item" role="presentation">
                              <label
                                className={`custom_radio me-2 mb-0 ${product_type === "variable" ? "active" : ""}`}
                                id="pills-profile-tab"
                                data-bs-toggle="pill"
                                data-bs-target="#pills-profile"
                                role="tab"
                                aria-controls="pills-profile"
                                aria-selected={product_type === "variable"}
                              >
                                <input
                                  type="radio"
                                  className="form-control"
                                  value="variable"
                                  name="product_type"
                                  {...register("product_type")}
                                />
                                <span className="checkmark" /> Variable Product
                              </label>
                            </li>
                          </ul>
                        </div>
                      </div>

                      <div className="tab-content" id="pills-tabContent">
                        <div
                          className={`tab-pane fade ${product_type === "single" ? "show active" : ""}`}
                          id="pills-home"
                          role="tabpanel"
                          aria-labelledby="pills-home-tab"
                        >
                          <div className="row">
                            <div className="col-lg-6 col-sm-6 col-12">
                              <div className="input-blocks add-product">
                                <label>Quantity</label>
                                <input
                                  type="number"
                                  {...register("quantity")}
                                  className="form-control no-spinner"
                                  aria-label="Quantity"
                                  style={{ height: '54px' }}
                                  onWheel={(e) => e.target.blur()}
                                />
                                {errors.quantity && (
                                  <span className="text-danger">{errors.quantity.message}</span>
                                )}
                              </div>
                            </div>

                            <div className="col-lg-6 col-sm-6 col-12">
                              <div className="input-blocks add-product">
                                <label>Price</label>
                                <input
                                  type="number"
                                  step="0.01"
                                  {...register("price")}
                                  className="form-control no-spinner"
                                  style={{ height: '54px' }}
                                  aria-label="Price"
                                  onWheel={(e) => e.target.blur()}
                                />
                                {errors.price && (
                                  <span className="text-danger">{errors.price.message}</span>
                                )}
                              </div>
                            </div>

                            <div className="col-lg-6 col-sm-6 col-12">
                              <div className="input-blocks add-product">
                                <label>Discount Type</label>
                                <Controller
                                  name="discount_type"
                                  control={control}
                                  render={({ field }) => (
                                    <Select
                                      options={discountTypeOptions}
                                      value={discountTypeOptions.find((o) => o.value === field.value)}
                                      onChange={(option) => field.onChange(option?.value)}
                                      placeholder="Choose"
                                      aria-label="Select discount type"
                                    />
                                  )}
                                />
                                {errors.discount_type && (
                                  <span className="text-danger">{errors.discount_type.message}</span>
                                )}
                              </div>
                            </div>

                            <div className="col-lg-6 col-sm-6 col-12">
                              <div className="input-blocks add-product">
                                <label>Discount Value</label>
                                <input
                                  type="number"
                                  step="0.01"
                                  {...register("discount_value")}
                                  className="form-control no-spinner"
                                  aria-label="Discount value"
                                  style={{ height: '54px' }}
                                />
                                {errors.discount_value && (
                                  <span className="text-danger">{errors.discount_value.message}</span>
                                )}
                              </div>
                            </div>

                            <div className="col-lg-6 col-sm-6 col-12">
                              <div className="input-blocks add-product">
                                <label>Low Stock</label>
                                <input
                                  type="number"
                                  {...register("low_stock")}
                                  className="form-control no-spinner"
                                  aria-label="Low Stock"
                                  onWheel={(e) => e.target.blur()}
                                  style={{ height: '54px' }}
                                />
                                {errors.low_stock && (
                                  <span className="text-danger">{errors.low_stock.message}</span>
                                )}
                              </div>
                            </div>
                          </div>
                        </div>

                        <div
                          className={`tab-pane fade ${product_type === "variable" ? "show active" : ""}`}
                          id="pills-profile"
                          role="tabpanel"
                          aria-labelledby="pills-profile-tab"
                        >
                          <div className="row select-color-add">
                            <div className="col-lg-6 col-sm-6 col-12">
                              <div className="input-blocks add-product">
                                <label>Variant Attribute</label>
                                <div className="row">
                                  <div className="col-lg-10 col-sm-10 col-10">
                                    <Controller
                                      name="variantAttribute"
                                      control={control}
                                      render={({ field }) => (
                                        <Select
                                          className="select"
                                          options={variantOptions}
                                          placeholder="Choose"
                                          value={variantOptions.find((option) => option.value === field.value)}
                                          onChange={(option) => field.onChange(option?.value)}
                                        />
                                      )}
                                    />
                                    {errors.variantAttribute && (
                                      <span className="text-danger">{errors.variantAttribute.message}</span>
                                    )}
                                  </div>

                                  <div className="col-lg-2 col-sm-2 col-2 ps-0">
                                    <div className="add-icon tab">
                                      <Link
                                        className="btn btn-added"
                                        data-bs-toggle="modal"
                                        data-bs-target="#add-units"
                                        onClick={handleAddVariants}
                                      >
                                        <PlusCircle className="feather feather-plus-circle" />
                                      </Link>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div
                                className="selected-hide-color"
                                id="input-show"
                              >
                                <div className="row align-items-center">
                                  <div className="col-sm-10">
                                    <div className="input-blocks">
                                      <input
                                        className="input-tags form-control"
                                        id="inputBox"
                                        type="text"
                                        data-role="tagsinput"
                                        name="specialist"
                                        defaultValue="red, black"
                                      />
                                    </div>
                                  </div>
                                  <div className="col-lg-2">
                                    <div className="input-blocks ">
                                      <Link to="#" className="remove-color">
                                        <Trash2 />
                                      </Link>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div
                            className="modal-body-table"
                            id="variant-table"
                          >
                            <table className="table">
                              <thead>
                                <tr>
                                  <th>Variants</th>
                                  <th>Variant Value</th>
                                  {/* <th>SKU</th> */}
                                  <th>Quantity</th>
                                  <th>Price</th>
                                  <th>Discount Type</th>
                                  <th>Discount Value</th>
                                  <th className="no-sort">Action</th>
                                </tr>
                              </thead>
                              <tbody>
                                {fields.map((field, index) => (
                                  <tr key={field.id}>
                                    <td>
                                      <div className="add-product">
                                        <input
                                          type="text"
                                          className="form-control"
                                          {...register(`variants.${index}.name`)}
                                          readOnly
                                        />
                                        {errors.variants?.[index]?.name && (
                                          <span className="text-danger">{errors.variants[index].name.message}</span>
                                        )}
                                      </div>
                                    </td>
                                    <td>
                                      <div className="add-product">
                                        <input
                                          type="text"
                                          className="form-control"
                                          {...register(`variants.${index}.variant_value`)}
                                          readOnly
                                        />
                                        {errors.variants?.[index]?.variant_value && (
                                          <span className="text-danger">{errors.variants[index].variant_value.message}</span>
                                        )}
                                      </div>
                                    </td>
                                    {/* <td>
                                      <div className="add-product">
                                        <input
                                          type="text"
                                          className="form-control"
                                          {...register(`variants.${index}.sku`)}
                                          readOnly
                                        />
                                        {errors.variants?.[index]?.sku && (
                                          <span className="text-danger">{errors.variants[index].sku.message}</span>
                                        )}
                                      </div>
                                    </td> */}

                                    <td>
                                      <div className="add-product">
                                        <input
                                          type="number"
                                          min={0}
                                          className="form-control no-spinner"
                                          {...register(`variants.${index}.quantity`)}
                                          onWheel={(e) => e.target.blur()}
                                        />
                                        {errors.variants?.[index]?.quantity && (
                                          <span className="text-danger">{errors.variants[index].quantity.message}</span>
                                        )}
                                      </div>
                                    </td>

                                    <td>
                                      <div className="add-product">
                                        <input
                                          type="number"
                                          step="0.01"
                                          className="form-control no-spinner"
                                          {...register(`variants.${index}.price`)}
                                          onWheel={(e) => e.target.blur()}
                                        />
                                        {errors.variants?.[index]?.price && (
                                          <span className="text-danger">{errors.variants[index].price.message}</span>
                                        )}
                                      </div>
                                    </td>

                                    <td>
                                      <Controller
                                        name={`variants.${index}.discount_type`}
                                        control={control}
                                        render={({ field }) => (
                                          <Select
                                            options={discountTypeOptions}
                                            value={discountTypeOptions.find((o) => o.value === field.value)}
                                            onChange={(option) => field.onChange(option?.value)}
                                            placeholder="Choose"
                                            aria-label="Select discount type"
                                          />
                                        )}
                                      />
                                      {errors.variants?.[index]?.discount_type && (
                                        <span className="text-danger">{errors.variants[index].discount_type.message}</span>
                                      )}
                                    </td>

                                    <td>
                                      <div className="add-product">
                                        <input
                                          type="number"
                                          step="0.01"
                                          className="form-control no-spinner"
                                          {...register(`variants.${index}.discount_value`)}
                                          onWheel={(e) => e.target.blur()}
                                        />
                                        {errors.variants?.[index]?.discount_value && (
                                          <span className="text-danger">{errors.variants[index].discount_value.message}</span>
                                        )}
                                      </div>
                                    </td>

                                    <td className="action-table-data">
                                      <div className="edit-delete-action">
                                        <Link
                                          className="me-2 p-2"
                                          to="#"
                                          data-bs-toggle="modal"
                                          data-bs-target="#edit-units"
                                        >
                                          <i data-feather="edit" className="feather-edit" />
                                        </Link>
                                        <Link
                                          className="confirm-text p-2"
                                          to="#"
                                          onClick={() => remove(index)}
                                        >
                                          <i data-feather="trash-2" className="feather-trash-2" />
                                        </Link>
                                      </div>
                                    </td>
                                  </tr>
                                ))}
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* Images section */}
              <div className="accordion-card-one accordion" id="accordionExample3">
                <div className="accordion-item">
                  <div className="accordion-header" id="headingThree">
                    <div
                      className="accordion-button"
                      data-bs-toggle="collapse"
                      data-bs-target="#collapseThree"
                      aria-controls="collapseThree"
                    >
                      <div className="addproduct-icon list">
                        <h5>
                          <i data-feather="image" className="add-info" />
                          <span>Images</span>
                        </h5>
                      </div>
                    </div>
                  </div>
                  <div
                    id="collapseThree"
                    className="accordion-collapse collapse show mt-2"
                    aria-labelledby="headingThree"
                    data-bs-parent="#accordionExample3"
                  >
                    <div className="accordion-body">
                      <div className="text-editor add-list add">
                        <div className="col-lg-12">
                          <div className="add-choosen">
                            <div className="input-blocks">
                              <div className="image-upload">
                                <input
                                  type="file"
                                  {...register("images")}
                                  multiple
                                  onChange={handleImageChange}
                                  className="form-control"
                                  aria-label="Upload images"
                                />
                                <div className="image-uploads">
                                  <PlusCircle className="plus-down-add me-0" />
                                  <h4>Add Images</h4>
                                </div>
                              </div>
                              {errors.images && imagePreviews.length === 0 && (
                                <span className="text-danger">{errors.images.message}</span>
                              )}
                            </div>
                            <div className="mt-2 d-flex gap-2 flex-wrap">
                              {imagePreviews.map((preview, index) => (
                                <div key={index} className="position-relative">
                                  <img
                                    src={preview}
                                    alt={`Preview ${index + 1}`}
                                    style={{ maxWidth: "100px", maxHeight: "100px" }}
                                  />
                                  <button
                                    type="button"
                                    className="btn btn-sm btn-danger position-absolute top-0 end-0"
                                    onClick={() =>
                                      setImagePreviews((prev) => prev.filter((_, i) => i !== index))
                                    }
                                    aria-label={`Remove image ${index + 1}`}
                                  >
                                    <X />
                                  </button>
                                </div>
                              ))}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div
                    id="collapseThree"
                    className="accordion-collapse collapse show"
                    aria-labelledby="headingThree"
                    data-bs-parent="#accordionExample3"
                  >
                    <div className="accordion-body">
                      <div className="text-editor add-list add">
                        <div className="custom-filed">
                          <div className="input-block add-lists">
                            <label className="checkboxs">
                              <input type="checkbox" {...register("is_warranty")} />
                              <span className="checkmarks" />
                              Warranties
                            </label>
                          </div>
                        </div>
                        <div className="row">
                          {isWarranty && (
                            <div className="col-lg-6 col-sm-6 col-12">
                              <div className="mb-3 add-product">
                                <label className="form-label">Warranty</label>
                                <Controller
                                  name="warranty"
                                  control={control}
                                  render={({ field }) => (
                                    <Select
                                      options={warrantyOptions}
                                      value={warrantyOptions.find((o) => o.value === field.value)}
                                      onChange={(option) => field.onChange(option?.value)}
                                      placeholder="Choose"
                                      aria-label="Select warranty"
                                    />
                                  )}
                                />
                                {errors.warranty && (
                                  <span className="text-danger">{errors.warranty.message}</span>
                                )}
                              </div>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* custom fields section */}
              {/* <div className="accordion-card-one accordion" id="accordionExample4">
                <div className="accordion-item">
                  <div className="accordion-header" id="headingFour">
                    <div
                      className="accordion-button"
                      data-bs-toggle="collapse"
                      data-bs-target="#collapseFour"
                      aria-controls="collapseFour"
                    >
                      <div className="text-editor add-list">
                        <div className="addproduct-icon list">
                          <h5>
                            <List className="add-info" />
                            <span>Custom Fields</span>
                          </h5>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    id="collapseFour"
                    className="accordion-collapse collapse show"
                    aria-labelledby="headingFour"
                    data-bs-parent="#accordionExample4"
                  >
                    <div className="accordion-body">
                      <div className="text-editor add-list add">
                        <div className="custom-filed">
                          <div className="input-block add-lists">
                            <label className="checkboxs">
                              <input type="checkbox" {...register("is_warranty")} />
                              <span className="checkmarks" />
                              Warranties
                            </label> */}
                            {/* <label className="checkboxs">
                              <input type="checkbox" {...register("is_manufacturer")} />
                              <span className="checkmarks" />
                              Manufacturer
                            </label>
                            <label className="checkboxs">
                              <input type="checkbox" {...register("is_expiry")} />
                              <span className="checkmarks" />
                              Expiry
                            </label> */}
                          {/* </div>
                        </div>
                        <div className="row">
                          {isWarranty && (
                            <div className="col-lg-6 col-sm-6 col-12">
                              <div className="mb-3 add-product">
                                <label className="form-label">Warranty</label>
                                <Controller
                                  name="warranty"
                                  control={control}
                                  render={({ field }) => (
                                    <Select
                                      options={warrantyOptions}
                                      value={warrantyOptions.find((o) => o.value === field.value)}
                                      onChange={(option) => field.onChange(option?.value)}
                                      placeholder="Choose"
                                      aria-label="Select warranty"
                                    />
                                  )}
                                />
                                {errors.warranty && (
                                  <span className="text-danger">{errors.warranty.message}</span>
                                )}
                              </div>
                            </div>
                          )} */}
                          {/* {isManufacturer && (
                            <>
                              <div className="col-lg-6 col-sm-6 col-12">
                                <div className="input-blocks add-product">
                                  <label>Manufacturer</label>
                                  <input
                                    type="text"
                                    {...register("manufacturer")}
                                    className="form-control"
                                    aria-label="Manufacturer"
                                  />
                                  {errors.manufacturer && (
                                    <span className="text-danger">{errors.manufacturer.message}</span>
                                  )}
                                </div>
                              </div>
                              <div className="col-lg-6 col-sm-6 col-12">
                                <div className="input-blocks">
                                  <label>Manufactured Date</label>
                                  <div className="input-groupicon calender-input">
                                    <Controller
                                      name="manufacturer_date"
                                      control={control}
                                      render={({ field }) => (
                                        <DatePicker
                                          value={field.value ? dayjs(field.value) : null}
                                          onChange={(date) => field.onChange(date ? date.toDate() : null)}
                                          format="DD-MM-YYYY"
                                          className="form-control"
                                          placeholder="Choose Date"
                                          aria-label="Select manufactured date"
                                        />
                                      )}
                                    />
                                    {errors.manufacturer_date && (
                                      <span className="text-danger">{errors.manufacturer_date.message}</span>
                                    )}
                                  </div>
                                </div>
                              </div>
                            </>
                          )} */}
                          {/* {isExpiry && (
                            <div className="col-lg-6 col-sm-6 col-12">
                              <div className="input-blocks">
                                <label>Expiry On</label>
                                <div className="input-groupicon calender-input">
                                  <Controller
                                    name="expiry_on"
                                    control={control}
                                    render={({ field }) => (
                                      <DatePicker
                                        value={field.value ? dayjs(field.value) : null}
                                        onChange={(date) => field.onChange(date ? date.toDate() : null)}
                                        format="DD-MM-YYYY"
                                        className="form-control"
                                        placeholder="Choose Date"
                                        aria-label="Select expiry date"
                                      />
                                    )}
                                  />
                                  {errors.expiry_on && (
                                    <span className="text-danger">{errors.expiry_on.message}</span>
                                  )}
                                </div>
                              </div>
                            </div>
                          )} */}
                        {/* </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div> */}

            </div>
          </div>
          <div className="col-lg-12">
            <div className="btn-addproduct mb-4">
              <button
                type="button"
                className="btn btn-cancel me-2"
                onClick={() => navigate(route.productlist)}
                disabled={isSubmitting}
              >
                Cancel
              </button>

              {(isEditMode ? permissions.update : permissions.create) && (
                <button
                  type="submit"
                  className="btn btn-submit"
                  disabled={isSubmitting}
                >
                  {isSubmitting ? "Saving..." : "Save Product"}
                </button>
              )}
            </div>
          </div>
        </form>
        <Addunits />
        <AddCategory />
        <AddBrand />
        <AddVariant
          variant={currentVariant}
          onSave={() => {
            hasFetched.current = false;
          }}
        />
      </div>
    </div>
  );
};

export default AddProduct;